import React from 'react';

// Dev-only wrapper around mobx-react-form-devtools. Forms are registered with
// the devtools store in BaseEditViewStore; this renders its dockable UI.
// Guarded require keeps the library out of the production bundle (DefinePlugin
// replaces process.env.NODE_ENV, then Terser drops the dead branch + its require).
let devtools = null;
let resizerCss = null;
if (process.env.NODE_ENV !== 'production') {
    devtools = require('mobx-react-form-devtools').default;
    // react-dock paints a default box-shadow on the dock panel. While the dock
    // is collapsed it sits at width 0 parked off the right edge, but that shadow
    // still bleeds ~4px back onto the page as a full-height line. The devtools
    // feeds react-dock's dockStyle from store.dock.style, so clearing the shadow
    // there removes the stray edge line while leaving the floating handle intact.
    // react-dock autoprefixes its default shadow, so the prefixed variants must
    // be cleared too — in Chrome -webkit-box-shadow aliases box-shadow and, being
    // applied last, would otherwise re-paint the line.
    const store = require('mobx-react-form-devtools/lib/store').default;
    store.dock.style = {
        ...store.dock.style,
        boxShadow: 'none',
        WebkitBoxShadow: 'none',
        MozBoxShadow: 'none',
        msBoxShadow: 'none',
        OBoxShadow: 'none'
    };
    // react-dock also renders a full-height, opacity:0 resize handle pinned to
    // the viewport edge. It has no prop to disable it, so it keeps intercepting
    // the page edge (col-resize cursor) even while the dock is collapsed. Scope
    // a rule to the devtools dock wrapper class and hide it — resizing the debug
    // dock isn't needed, and this leaves every other resizer on the page alone.
    const dockClass = require('mobx-react-form-devtools/lib/styles/Dock').default.dock;
    resizerCss = `.${dockClass} div[style*="col-resize"]{display:none;}`;
}

const FormDebugPanel = () => devtools
    ? (
        <React.Fragment>
            <style>{resizerCss}</style>
            <devtools.UI/>
        </React.Fragment>
    )
    : null;

export default FormDebugPanel;
